import { EXPLO_DASHBOARD } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useExploDashboard() {
  return useIsFeatureEnabled(EXPLO_DASHBOARD);
}
